import buildComponent from './utils/build-component';
import checkIntersection from './utils/check-intersection';

export default (nameSpace, selector) => buildComponent({
  nameSpace,
  selector,
  initState: {
    isInView: false,
  },
  initFunction: ($el, params) => {
    let slider;

    //
    // Methods
    //

    function initSlider() {
      import(/* webpackChunkName: "chunk-swiper" */ `swiper`).then(module => {
        const Swiper = module.default;
        slider = new Swiper($el.querySelector('.swiper-container'), params.swiperConfig)
      })
    }

    //
    // Life Cycle
    //

    params.onStateUpdate((newState, prevState) => {
      if (!prevState.isInView && newState.isInView) {
        initSlider();
      }
    });

    //
    // Procedures
    //

    checkIntersection($el, () => {
      params.setState({ isInView: true });
    });

    //
    // Public API
    //

    return {
      get swiperInstance() {
        return slider;
      } 
    };
  }
});



// WEBPACK FOOTER //
// ./src/scripts/slider.js